import React from "react";
import { IconButton } from "../core/IconButton.jsx";

export function Pagination({ page = 1, pages = 1, onChange, rangeLabel, style = {} }) {
  const go = (p) => onChange && onChange(Math.min(pages, Math.max(1, p)));
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4, ...style }}>
      {rangeLabel ? <span style={{ fontSize: "var(--fs-12)", color: "var(--fg-8)", whiteSpace: "nowrap", marginRight: 8 }}>{rangeLabel}</span> : null}
      <IconButton icon="chevrons-left" tip="Erste Seite" bordered onClick={() => go(1)} />
      <IconButton icon="chevron-left" tip="Vorherige Seite" bordered onClick={() => go(page - 1)} />
      <div style={{ display: "flex", alignItems: "baseline", gap: 5, padding: "0 10px", fontSize: "var(--fs-13)", color: "var(--fg-4)", whiteSpace: "nowrap" }}>
        <span style={{ color: "var(--fg-1)", fontWeight: "var(--fw-semibold)" }}>{page}</span>
        <span style={{ color: "var(--fg-9)" }}>/</span>
        <span>{pages}</span>
      </div>
      <IconButton icon="chevron-right" tip="Nächste Seite" bordered onClick={() => go(page + 1)} />
      <IconButton icon="chevrons-right" tip="Letzte Seite" bordered onClick={() => go(pages)} />
    </div>
  );
}
